import { render, staticRenderFns } from "./TextBlockWithCounter.vue?vue&type=template&id=6981fdef"
import script from "./TextBlockWithCounter.vue?vue&type=script&lang=js"
export * from "./TextBlockWithCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports